import React from "react";
import styled from "styled-components";
import Sparkline, { IProps as SparklineProps } from "./sparkline";

type IProps = SparklineProps & {
  isSmall: boolean;
  disableAnimation?: boolean;
};

const Trend = styled.div<{ isSmall: boolean }>`
  flex-grow: 1;
  overflow: hidden;
  > div {
    height: ${({ isSmall }) => !isSmall && "148px"};
  }
`;

const MetricTrendTrends = ({
  data,
  isSmall,
  color,
  polarizeColors,
  disableAnimation = false,
}: IProps) => {
  return (
    <Trend isSmall={isSmall}>
      <Sparkline
        data={data}
        color={color}
        polarizeColors={polarizeColors}
        disableAnimation={disableAnimation}
      />
    </Trend>
  );
};

export default MetricTrendTrends;
